<template>
	<div class="wrapper-table">
		<slot></slot>
		<div class="content-table">
			<itemTable v-for="item in userList" :key="item.id" :items="item"></itemTable>
		</div>	
	</div>
</template>

<script>
import itemTable from "../Componentes/itemTable";
import { mapGetters } from 'vuex'
export default {
  name: "tableContent",
	components:{
		itemTable
	},
  data() {
    return {
      itemsBuild: [
        { id: 1, name: "Algun Usuario", email:"unemail@gmail.com", password: "password1", permiso: "Master", estado:true, editar: "*" },
        { id: 2, name: "Algun Usuario", email:"unemail@gmail.com", password: "password2", permiso: "Master", estado:true, editar: "*" },
        { id: 3, name: "Algun Usuario", email:"unemail@gmail.com", password: "password3", permiso: "Master", estado:true, editar: "*" },
        { id: 4, name: "Algun Usuario", email:"unemail@gmail.com", password: "password4", permiso: "Master", estado:false, editar: "*" },
        { id: 5, name: "Algun Usuario", email:"unemail@gmail.com", password: "password5", permiso: "Master", estado:false, editar: "*" },
        { id: 6, name: "Algun Usuario", email:"unemail@gmail.com", password: "password6", permiso: "Master", estado:false, editar: "*" }
      ]
    };
  },
  computed: {
    ...mapGetters(['userList'])
  }
};
</script>

<style>
.content-table{
  max-width: 1200px;
  padding: 0 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/tableContent.vue